module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/holes/door-double/door_double.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/holes/door-double/door_double.png
// module id = 470
// module chunks = 0